import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Button, Col, Panel, Row } from 'react-bootstrap'
import autobind from 'autobind-decorator'
import {
  submitBook,
  histPaymentPage,
  populatePopupError,
  initRoomPrices,
  findLocalRooms,
  startHoldTimer
} from '../redux/actions'
import RoomBookNavTabs from '../components/roomBookNavTabs'
import * as utils from '../utils'
import { daysBetween } from '../utils/dateUtils'
import {
  getFieldsFromCache,
  getGuestInitFields,
  getObjFromCache
} from '../redux/stateUtils'
import { guestEntryFields, defaultPayingGuestValue } from '../redux/formSchema'
import { reduxForm, getValues } from 'redux-form'
import _ from 'lodash'
import BottomNavigationButtons from './bottomNavigationButtons'
import CheckInOutDates from '../components/checkInOutDates'
import CancellationPolicy from '../components/content/cancellationPolicy'
import {
  programSelector,
  roomSearchParamsSelector
} from '../redux/modules/searchParamsModule'
import { getPriceFromSelections } from '../logic/pricingLogic'
import history from '../history'
import { updateTotalPayment } from '../redux/modules/paymentModule'
import { initializeCard, tokenize } from '../utils/clientPaymentUtils'
import LoadingSpinner from '../components/loader'

function CancellationPolicySection({ program }) {
  return (
    <div style={{ margin: '2rem 0' }}>
      <CancellationPolicy program={program} />
    </div>
  )
}

@autobind
class Payment extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    payment: PropTypes.object,
    dp: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.state = {
      formErrors: '',
      onSubmitPayment: undefined,
      isLoading: true,
      isProcessingPayment: false
    }
  }

  handlePrevBtn(event) {
    if (event) event.preventDefault()
    var path = this.props.location.pathname
    if (path !== '/guestentry' && path !== '/results') {
      history.push('/guestentry')
    }
  }

  onBypassPayment() {
    const {
      dispatch,
      payment: { amount }
    } = this.props
    if (
      window.confirm(
        'Are you sure you want to bypass payment? Credit card will not be charged.'
      )
    ) {
      dispatch(submitBook(true, { amount: amount }))
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props
    dispatch(histPaymentPage())
  }

  componentWillMount() {
    const {
      dispatch,
      history: { prevPage },
      payment: { amount },
      searchResults,
      bookingDetails: { currentState }
    } = this.props
    const fieldsObj = getFieldsFromCache()
    if (prevPage === '') {
      dispatch(findLocalRooms())
    }
    const isEmptySearchDataAvail = !searchResults || searchResults.length === 0
    if (amount === 0 && isEmptySearchDataAvail && !fieldsObj) {
      // If user tries go to the payment page directly then it'l redirect to search page
      history.push('/search')
    } else if (currentState !== 'GE_COMPLETED') {
      history.push('/guestentry')
    } else {
      if (prevPage === '') {
        dispatch(startHoldTimer())
      }
    }
  }

  // Updates the amount of the selected rooms
  updateAmount(callback) {
    const {
      searchParams: { checkInDate, checkOutDate },
      fields: { listings, guestDetails },
      history: { prevPage },
      dispatch,
      payment: { amount },
      roomPrices,
      rooms,
      program
    } = this.props

    const paymentAmount = getPriceFromSelections(
      roomPrices,
      getValues(listings),
      rooms,
      prevPage,
      true,
      guestDetails,
      dispatch,
      program
    )

    const totalPayment = paymentAmount * daysBetween(checkInDate, checkOutDate)

    if (amount === 0 && totalPayment > 0) {
      const pricePanel = getObjFromCache('pricePanel')
      let updatedAmount = 0
      if (pricePanel && pricePanel.useCustomAmount && pricePanel.customAmount) {
        updatedAmount = pricePanel.customAmount
        dispatch(updateTotalPayment({ amount: pricePanel.customAmount }))
      } else {
        updatedAmount = totalPayment
        dispatch(updateTotalPayment({ amount: totalPayment }))
      }
      if (callback) callback(updatedAmount)
    }
  }

  initForm(updatedAmount) {
    const self = this

    const locationId = extConfig.LOCATION_ID
    const applicationId = extConfig.APPLICATION_ID

    if (applicationId === '') {
      this.props.dispatch(
        populatePopupError(
          'You need to provide a value for the applicationId variable.'
        )
      )
    }

    if (!window.Square) {
      throw new Error('Square.js failed to load properly')
    }

    // Show success message to the browser console
    console.log('Square.js successfully loaded')

    let payments
    try {
      payments = window.Square.payments(applicationId, locationId)
    } catch (error) {
      console.error(error)
      this.props.dispatch(
        populatePopupError(
          `There was an error loading the payment form. Please try again or contact us at ${extConfig.SUPPORT_CONTACT}`
        )
      )
      return
    }

    let card
    initializeCard(payments, '#card-container')
      .then(cardInstance => {
        card = cardInstance
        // Checkpoint 2.
        function handlePaymentMethodSubmission(event, paymentMethod) {
          event.preventDefault()
          self.setState({ isProcessingPayment: true })

          console.log('Payment method submitted', paymentMethod)
          tokenize(paymentMethod)
            .then(token => {
              return self.props.dispatch(
                submitBook(false, {
                  amount: updatedAmount,
                  sourceId: token,
                  locationId
                })
              )
            })
            .catch(e => {
              this.props.dispatch(
                populatePopupError(
                  `There was an error processing the payment. Please try again or contact us at ${extConfig.SUPPORT_CONTACT}`
                )
              )
              console.error(e)
            })
            .finally(() => {
              self.setState({ isProcessingPayment: false })
            })
        }

        this.setState({
          isLoading: false,
          onSubmitPayment: () => handlePaymentMethodSubmission(event, card)
        })
      })
      .catch(e => {
        this.props.dispatch(
          populatePopupError(
            `There was an error loading the payment form. Please try again or contact us at ${extConfig.SUPPORT_CONTACT}`
          )
        )
        console.error(e.message)
      })
  }

  componentDidMount() {
    const {
      payment: { amount },
      roomPrices
    } = this.props
    if (!roomPrices || roomPrices.length === 0) {
      this.props.dispatch(
        initRoomPrices(() => {
          this.forceUpdate()
          this.updateAmount(updatedAmount => {
            this.initForm(updatedAmount)
          })
        })
      )
    } else {
      const fieldsObj = getFieldsFromCache()
      if (amount !== 0 || fieldsObj) {
        this.updateAmount()
        this.initForm(amount)
      }
    }
  }

  getCheckInOutDates() {
    const {
      searchParams: { checkInDate, checkOutDate }
    } = this.props
    return (
      <CheckInOutDates checkInDate={checkInDate} checkOutDate={checkOutDate} />
    )
  }

  render() {
    const {
      auth: { authenticated },
      payment: { amount },
      program
    } = this.props

    const { isProcessingPayment } = this.state

    let errorDiv = null
    if (!utils.isEmpty(this.state.formErrors)) {
      errorDiv = _.flatMap(this.state.formErrors, (error, roomIndex) => {
        return (
          <Row>
            <Col lg={8} md={8} sm={12} xs={12}>
              <label className='alert payment-errors alert-danger col-md-12 col-sm-12 col-lg-12 col-xs-12'>
                {' '}
                {error}
              </label>
            </Col>
          </Row>
        )
      })
    }
    return (
      <div>
        <Row>
          <Col md={12}>
            <RoomBookNavTabs {...this.props} />
          </Col>
          <div className='panel-pl-0 mt-5'>
            <Panel>
              <Col md={8} lg={9}>
                <Panel>
                  <Row>
                    <Col md={12} lg={8}>
                      <h3>Please complete your payment below</h3>
                      <CancellationPolicySection program={program} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>{errorDiv}</Col>
                  </Row>
                  <Row>
                    <div className='mt-2'>
                      <Col md={12}>
                        {/* <Row>
                          <Col md={3}>
                            <label>Card Number</label>
                          </Col>
                          <Col md={5}>
                            <div id='sq-card-number' />
                          </Col>
                          <Col />
                        </Row>
                        <Row>
                          <Col md={3}>
                            <label>CVV</label>
                          </Col>
                          <Col md={5}>
                            <div id='sq-cvv' />
                          </Col>
                          <Col />
                        </Row>
                        <Row>
                          <Col md={3}>
                            <label>Expiration Date</label>
                          </Col>
                          <Col md={5}>
                            <div id='sq-expiration-date' />
                          </Col>
                          <Col />
                        </Row>
                        <Row>
                          <Col md={3}>
                            <label>Postal Code</label>
                          </Col>
                          <Col md={5}>
                            <div id='sq-postal-code' />
                          </Col>
                          <Col />
                        </Row> */}
                        <div id={'card-container'}></div>
                        {this.state.isLoading ? (
                          <LoadingSpinner
                            style={{
                              width: '10em',
                              float: 'left',
                              display: 'block'
                            }}
                          />
                        ) : (
                          <Row>
                            <Col
                              lg={2}
                              lgPush={5}
                              md={1}
                              mdPush={5}
                              sm={2}
                              smPush={5}
                              xs={3}
                              xsPush={4}
                            >
                              <button
                                type='submit'
                                className='btn btn-success payment-submit'
                                disabled={isProcessingPayment}
                                onClick={this.state.onSubmitPayment}
                              >
                                {isProcessingPayment
                                  ? 'Processing...'
                                  : 'Submit'}
                              </button>
                              <div id='payment-status-container'></div>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </div>
                  </Row>
                </Panel>
              </Col>
              <Col style={{ float: 'left' }} xs={12} sm={12} md={4} lg={3}>
                <Row>
                  <div className='pricePanels'>
                    <Col sm={12} lg={12}>
                      {this.getCheckInOutDates()}
                      <Panel className='checkin-payment'>
                        Total Price : ${amount}
                      </Panel>
                    </Col>
                  </div>
                </Row>
                {authenticated && this.props.showBypassPayment ? (
                  <Row>
                    <Col sm={12}>
                      <Button bsStyle='warning' onClick={this.onBypassPayment}>
                        Bypass payment
                      </Button>
                    </Col>
                  </Row>
                ) : null}
              </Col>
            </Panel>
          </div>
        </Row>
        <Row>
          <Col>
            <form id='nonce-form' formNoValidate action='test' method='post'>
              <input type='hidden' id='card-nonce' name='nonce' />
              <BottomNavigationButtons
                {...this.props}
                showBack
                showNext
                nextCB={this.requestCardNonce}
                backCB={this.handlePrevBtn}
                nextLabel='Submit'
                customClass='payment-navigation'
              />
            </form>
          </Col>
        </Row>
      </div>
    )
  }
}

function selectProps(state) {
  let rooms = state.rooms
  const roomsFromCache = getObjFromCache('rooms')
  if (Object.keys(rooms).length === 0 && roomsFromCache) {
    rooms = roomsFromCache
  }
  const searchDetails = getObjFromCache('searchDetails')

  return {
    payment: state.payment,
    auth: state.common.authentication,
    searchParams: roomSearchParamsSelector(state),
    searchResults: searchDetails,
    history: state.common.history,
    roomPrices: state.common.roomPrices,
    rooms: rooms,
    bookingDetails: state.common.bookingDetails,
    holdStatus: state.roomSearch.holdStatus,
    showBypassPayment: state.common.authentication.level === 3,
    program: programSelector(state),
    locationId: state.payment.locationId
  }
}

const reduxFormFunc = reduxForm(
  {
    form: 'roomSelection',
    destroyOnUnmount: false,
    fields: guestEntryFields,
    initialValues: getGuestInitFields(defaultPayingGuestValue)
  },
  selectProps
)
export default reduxFormFunc(Payment)



// WEBPACK FOOTER //
// ./src/containers/payment.js